export const environment = {
    production: true,
    clientUrl: "https://staging-outlook-addin.theadaptway.com",
    lumiaUrl: "https://staging-lumia.theadaptway.com",
    apiUrl: "https://staging-api.theadaptway.com",
    AdaptEnvironmentName: "Staging",
    SentryDsn: "https://50bf0bdf81be4c4bae2a9d610002da9e@o96030.ingest.sentry.io/6055662",
};
